/** Chronological order for meeting-notes chat history rows (GET .../meeting/{id}/history). */

function historySortKey(item: unknown): number {
  if (item == null || typeof item !== "object") return 0;
  const o = item as Record<string, unknown>;
  const candidates = [
    o.created_at,
    o.createdAt,
    o.updated_at,
    o.updatedAt,
    o.timestamp,
    o.time,
  ];
  for (const c of candidates) {
    if (typeof c === "number" && !Number.isNaN(c)) return c;
    if (typeof c === "string") {
      const d = Date.parse(c);
      if (!Number.isNaN(d)) return d;
    }
  }
  const id = o.chat_log_id ?? o.id;
  if (typeof id === "number" && !Number.isNaN(id)) return id;
  if (typeof id === "string" && /^\d+$/.test(id)) return parseInt(id, 10);
  return 0;
}

export function sortMeetingChatHistoryChronologically<T>(history: T[]): T[] {
  if (!Array.isArray(history)) return [];
  return [...history].sort(
    (a, b) => historySortKey(a) - historySortKey(b)
  );
}
